import { render, staticRenderFns } from "./PauseLightPartnership.vue?vue&type=template&id=695a5c7e"
import script from "./PauseLightPartnership.vue?vue&type=script&lang=js"
export * from "./PauseLightPartnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports